import React, { useEffect, useState } from 'react';
import './App.css';
import Homepage from './components/Homepage';
import Projects from './components/Projects';
import Educations from './components/Educations';
import Careers from './components/Careers';
import Footer from './components/Footer';

function App() {

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Set isMobile to true if screen width is less than or equal to 768px
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Call handleResize initially to set isMobile based on current screen size

    return () => {
      window.removeEventListener('resize', handleResize); // Cleanup
    };
  }, []);

  if (isMobile) {
    return <div className='mobile-alert'><span> Much sadness 😞
    so small screen, very sad
plz open on table or pc
for better view, such comfort
doge feels your sadness, so sad
  many virtual hugs, much support
hue hue hue, but also sympathy 🥺.</span>
      <img src='https://media.tenor.com/FNIgO7v9oiEAAAAM/k%C3%B6pke.gif'></img></div>; // Don't render anything if on a mobile device
  }

  return (
    <div className="App">
      <Homepage />
      <div className='resume-download-section'>
        <p>Hi 🐵, Get my Resume here 🫡 - <a href='https://drive.google.com/file/d/1_vpOg6DwvIA8yGslYy1usjtSuErO_dzI/view?usp=sharing' target="_blank" className='btn'>Resume</a></p>
      </div>
      <Careers />
      <Projects />
      <Educations />
      <Footer />
    </div>
  );
}

export default App;
